export default __webpack_public_path__ + "static/media/sport-100-kls.10b23174.svg";